import * as React from 'react';

const SubtractIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <path
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M.75 12.038h22.5"
        />
    </svg>
);
export default SubtractIcon;
